
<template>
	<div class="headder">
		<div class="head-cont clear">
			<div class="logo-lk fl">
				<a :href="baseUrl" class="logo-c">
					<img v-if="logoUrl" :src="BASE_URL + logoUrl" alt="logo">
					<!-- <img v-else src="../../../../public/logo.png" alt="logo"> -->
				</a>
				<a v-if="logoTxt" :href="baseUrl" class="logo-txt">{{logoTxt}}</a>
				<i>·</i>
				<router-link to="/prepare" class="link-home">备课</router-link>
			</div>
			<div class="logo-path fr">
				<!-- <template>
					<router-link v-if="isAdd" to="/prepare/add">新建备课</router-link>
				</template> -->
				<router-link v-if="isAdd" :to="{path: '/prepare/add',query: {type: type}}">新建备课</router-link>
				<!-- <router-link v-if="isTask" to="/prepare/task-add">新建任务</router-link> -->
			
			</div>
		</div>
	</div>
</template>

<script>
	
	export default{
		data(){
			return {
				baseUrl: process.env.BASE_URL,
				// isTask: false,
				isAdd: true,
				type: 0,
				logoUrl: sessionStorage.getItem('logoUrl'),
				logoTxt: sessionStorage.getItem('logoTxt')
			}
		},
		watch: {
		    $route: {
		      handler(newName, oldName) {
		     
		      	if (newName.name == 'task') {
		      		// this.isTask = true
		      		this.isAdd = false
		      	}else if (newName.name == 'personal' || newName.name == 'collective' ) {
		      		// this.isTask = false
		      		this.isAdd = true

		      		if (newName.name == 'personal') {
		      			this.type = 0
		      		}else if (newName.name == 'collective') {
		      			this.type = 1
		      		}
		      	}else{
		      		// this.isTask = false
		      		this.isAdd = false
		      	}
		       
		      },
		      deep: true
		  },
		},
		created(){
			
		},
		methods: {

		}
	}
</script>

<style lang="scss">
	.headder{
		background: #fff;
		height: 80px;
		box-shadow: 0 2px 4px 0 rgba(195,195,195,0.30);
	}
	.head-cont{
		padding: 15px 25px 0 25px;
	}
	.logo-c{
		display: inline-block;
		vertical-align: top;
		max-width: 180px;
		height: 40px;
		overflow: hidden;
		>img{
			width: 100%;
			// max-height: 40px;
		}
		>span{
			font-size: 22px;
			margin: 0 5px 0 10px;
			font-weight: bold;
		}
	}
	.logo-lk{
		>a{
			line-height: 40px;
		}
		>i{
			margin: 0 5px;
			font-weight: bold;
		}
		.link-home{
			font-size: 16px;
			color: #000000;
			letter-spacing: 2px;

		}
	}

	.train-test{
		button{
			background: #348EFC;
			border-radius: 3px;
			width: 120px;
			height: 36px;
			line-height: 36px;
			text-align: center;
			color: #fff;
			padding: 0;
		}
		>a,>span{
			display: inline-block;
			vertical-align: top;
			line-height: 36px;
			color: #338efc;
			margin-right: 30px;
			cursor: pointer;
		}
	}
</style>